<nb-card>
  <nb-card-header>
    <div class="menu-buttons"></div>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <ngx-layout-dept-detail
      *ngIf="shop.code !== 'TamTAX'"
      [shopId]="shopId"
      [uid]="uid"
      [shop]="shop"
      [object]="object"
      [mode]="mode"
      [type]="type"
      [fromDate]="fromDate"
      [toDate]="toDate"
      [deptDetail]="deptDetail"
      [paymentDebits]="paymentDebits"
      [initAmount]="initAmount"
      [saleAmount]="saleAmount"
      [paidAmount]="paidAmount"
      [debitAmount]="debitAmount"
      [discountAmount]="discountAmount"
      (onExport)="exportAsXLSX()"
    >
    </ngx-layout-dept-detail>

    <ngx-layout-dept-detail-tamtax
      *ngIf="shop.code === 'TamTAX'"
      [shopId]="shopId"
      [uid]="uid"
      [shop]="shop"
      [object]="object"
      [mode]="mode"
      [type]="type"
      [fromDate]="fromDate"
      [toDate]="toDate"
      [deptDetail]="deptDetail"
      [paymentDebits]="paymentDebits"
      [initAmount]="initAmount"
      [saleAmount]="saleAmount"
      [paidAmount]="paidAmount"
      [debitAmount]="debitAmount"
      [discountAmount]="discountAmount"
      (onExport)="exportAsXLSX()"
    >
    </ngx-layout-dept-detail-tamtax>
  </nb-card-body>

  <nb-card-footer>
    <!--- This is hidden using CSS ----->
    <button
      type="button"
      class="btn btn-sm d-none"
      ngxPrint
      printSectionId="print-section"
      styleSheetFile="assets/css/layout-print.css"
      #printBtn
      ngxPrint
    >
      Auto Print
    </button>

    <button
      *ngIf="!printing"
      nbButton
      hero
      shape="semi-round"
      status="info"
      size="medium"
      (click)="print()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      id="btnPrint"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      {{ "buttons.print" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
